import {Component} from 'react';
import "./GameViews/gameViews.css";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {doubleToStringMonthly} from '../../objects/CommonUse/double_functions';
import {rollForwardCash} from './objects/roll_forward_cash_function';
import { reformatDateToDisplay } from '../../objects/CommonUse/reformatDateToDisplay_function';
import { rollForwardDate } from "./objects/roll_forward_date_function";
import TwoColumnTableCard from './two_column_table_card';
import estimateUnplannedExpenses from './objects/estimate_unplanned_expenses';
import { getBasicSavingsAmts } from './objectsStatus/get_basic_saving_amts';
import { savingsOverTimeAmt } from '../../objects/CommonUse/savingsOverTimeCalc_function';

class FutureViewModal extends Component {
            constructor(props) {
              super(props);
              this.gameInfo = this.props.gameInfo();
              this.state={
                data: null,
                loading: true,
                monthAmtObj: {},
                assetTable: [],
                rollForwardSw: false,
                value: "",
                rerender: false,
              };    
        this.gameData = {};
        this.savingsInfo = {};
        this.startDate = "";
        this.endDate = "";
        this.gameDate = "";
        this.currentGameDate = "";
        this.currentCash = 0;
        this.newGameDate = "";
        this.endingCashAmt = 0;
        this.loanArray = [];
        this.displaySavings = false;
        this.nbrYears = 0;
        this.getAmtData();
        this.rollForward();
    }
    
    getAmtData() {
        this.gameData = JSON.parse(JSON.stringify(this.gameInfo.gameData));
        this.startDate = this.gameData.startGameDate;
        this.gameDate = this.gameData.currentGameDate;
        this.currentGameDate = this.gameData.currentGameDate;
        this.currentCash = this.gameData.currentCash;
        if (this.gameData.spendingHistory.turnCashArr ){
            const unplannedExpensesObj = 
                estimateUnplannedExpenses(this.gameData.spendingHistory.turnCashAmtArr,
                    this.gameData.spendingHistory.turnCreditAmtArr );
            this.unplannedExpenses = (+unplannedExpensesObj.averageAmt * -1).toFixed(2);
        }else{
            this.unplannedExpenses = 0;
        }
        
    }

    handlePeriodChange(nbrYears) {
        this.setState({rerender: false});
        this.nbrMonths = +nbrYears * 12;
        this.nbrYears = nbrYears;
        this.rollForward();
        this.setState({rerender: true});
    }

    rollForward() {
        if (!this.nbrMonths || this.nbrMonths === 0){
            this.nbrMonths = 0;
            this.startingCashDisplay = 0;
        }
        this.calculateAmounts();
    }

    calculateAmounts(){
        this.startingCashDisplay = JSON.parse(JSON.stringify(this.currentCash));
        this.assetTable = JSON.parse(JSON.stringify(this.gameData.assetTable));
        this.expenseTable = JSON.parse(JSON.stringify(this.gameData.expenseTable));
        this.loanTable = JSON.parse(JSON.stringify(this.gameData.loanTable));
        this.combineCashCreditTurnAmts(this.gameInfo.gameData.spendingHistory);
        let creditCardActive = false;
        if (this.gameInfo.creditCardInfo.currentlyActive &&
            this.gameInfo.creditCardInfo.currentlyActive === true){
                creditCardActive = true;
        }
        this.totalAmtObj = rollForwardCash(this.assetTable, this.expenseTable,
                this.loanTable, this.currentGameDate, creditCardActive, 
                this.gameInfo.timeWizardInfo, this.nbrMonths, true);
        this.newGameDate = this.totalAmtObj.newGameDate;
        // removed unplanned expenses from this calc as those costs may not be realistic
        this.totalExpenseAmt = +this.totalAmtObj.totalExpCashAmt + +this.totalAmtObj.totalExpChargeAmt;  
        this.totalSavingsAmt = 0;
        if (this.gameInfo.savingsInfo.gameID && this.gameInfo.savingsInfo.currentlyActive === true){
            const savingsArr = this.gameInfo.savingsInfo.savingsArr;
            let monthlySavingsAmt = 0;
            for (let i=0; i<savingsArr.length; i++){
                monthlySavingsAmt += +savingsArr[i].monthlyDepositAmt;
            }
            this.totalSavingsAmt = +monthlySavingsAmt * this.nbrMonths;
        }
        if (this.nbrMonths === 0){
            this.endingCashAmt = +this.currentCash;
        }else{
            this.endingCashAmt = +this.totalAmtObj.totalNetAmt + +this.currentCash - 
                this.totalSavingsAmt;
        }
        if (this.nbrMonths !== 0){
            this.setLoanDisplayInfo();
        }else{
            this.loanArray = [];
        }
        this.processSavingsInfo();
    }

    combineCashCreditTurnAmts(spendingHistory){
        this.cashCreditTurnAmtArr = [];
        if (spendingHistory.turnCashAmtArr){
            // skipping last entry of the cash and credit table as these might be partial month amounts
            // ... depending on when the player decides to go to this process.
            const nbrEntries = spendingHistory.turnCashAmtArr.length - 1;
            for (let i=0; i<nbrEntries; i++){
                let amount = +spendingHistory.turnCashAmtArr[i];
                let creditArrLength = i + 1;
                if (spendingHistory.turnCreditAmtArr &&
                    spendingHistory.turnCreditAmtArr.length >= creditArrLength){
                    amount = amount + +spendingHistory.turnCreditAmtArr[i];
                }
                this.cashCreditTurnAmtArr.push(amount);
            }
        }
    }

    setLoanDisplayInfo() {
        this.loanArray = [];
        var loanString = {};
        for (let i=0; i< this.loanTable.length; i++) {
            if (this.loanTable[i].loanNbrMonths !==0) {
                let loanNbrMonths = this.loanTable[i].loanTerm * 12;
                let loanEndDate = rollForwardDate(this.loanTable[i].loanStartDate, loanNbrMonths);
                if (loanEndDate >= this.newGameDate){
                    loanString = {label: this.loanTable[i].loanDesc, loanEndDate: loanEndDate,
                        class: "font_color_white"}
                    this.loanArray.push(loanString);
                }
            }
        }
    }

    processSavingsInfo(){
        this.savingsInfo = JSON.parse(JSON.stringify(this.gameInfo.savingsInfo));
        if (this.savingsInfo.gameID){
            const savingsObj = getBasicSavingsAmts(this.savingsInfo);
            this.currentSavingsAmt = savingsObj.beginBalance;
            this.monthlySavingsAmt = savingsObj.monthlySavingsAmt;
            this.savingsDeposits = savingsObj.monthlySavingsAmt * this.nbrMonths;
            let intRate = .05;
            this.savingsAmt = savingsOverTimeAmt(this.monthlySavingsAmt, intRate, 
                    this.nbrYears, this.currentSavingsAmt) 
            if (+this.savingsAmt > 0){
                this.savingsIntAmt = +this.savingsAmt - this.currentSavingsAmt -
                    this.savingsDeposits;
            }
            this.displaySavings = true;
        }else{
            this.displaySavings = false;
        }
    }

render() {
    this.collegeLoanList = this.loanArray.map((loanArr,key) =>
        <TwoColumnTableCard  key={key} infoType="label-date" outInfo={loanArr}  />
    );
return <>
    <Modal className="text-center" show={this.props.modalOpen}  onHide={() => this.props.onClose()} 
            size="med" scrollable="true">
    <Modal.Header className="futureModalHdrFooterBackground" closeButton>
          <Modal.Title>Look Into the Future</Modal.Title>
    </Modal.Header>
    <Modal.Body className="futureModalBackgroundImage">
        <span>
            <div className="row w-100 mx-0">
            <div className="col-sm-8 text-left text-white">Nbr of Years to Roll Forward:</div>
                <div className="col-sm-2 text-right">
                    <select onChange={(val) => this.handlePeriodChange(val.target.value)} 
                        className="text-white btn btn-sm btn-outline-secondary dropdown-toggle">
                            <option value="0">Current Values</option>
                            <option value="1">1 Year</option>
                            <option value="2">2 Years</option>
                            <option value="5">5 Years</option>
                            <option value="10">10 Years</option>
                            <option value="20">20 Years</option>
                            <option value="30">30 Years</option>
                    </select>
                </div>
            </div>
            <div className="mt-4"></div>
            <table className="table table-hover text-white">
                <tbody>
                    <tr>
                        <td className="text-left col-sm-8 p-0">Starting Game Date</td>
                        <td className="text-right col-sm-4 p-0">{reformatDateToDisplay(this.startDate)}</td>
                    </tr>
                    <tr>
                        <td className="text-left col-sm-8 p-0" >Current Game Date</td>
                        <td className="text-right col-sm-4 p-0">{reformatDateToDisplay(this.currentGameDate)}</td>
                    </tr>
                    <tr>
                        <td className="text-left col-sm-8 p-0" >Current Cash Amount</td>
                        <td className="text-right col-sm-4 p-0"> {doubleToStringMonthly(this.startingCashDisplay)}</td>
                    </tr>
                    <tr>
                        <td className="text-left col-sm-8 p-0" >Total Income (Salary and Other)</td>
                        <td className="text-right col-sm-4 p-0"> {doubleToStringMonthly(this.totalAmtObj.totalAssetAmt)}</td>
                    </tr>
                    <tr> 
                        <td className="text-left col-sm-8 p-0" >Total Estimated Expenses</td>
                        <td className="text-right col-sm-4 p-0">- {doubleToStringMonthly(this.totalExpenseAmt)}</td>
                    </tr>
                    <tr> 
                        <td className="text-left col-sm-8 p-0" >Total Loan Payments</td>
                        <td className="text-right col-sm-4  p-0">- {doubleToStringMonthly(this.totalAmtObj.totalLoanPayments)}</td>
                    </tr>
                    <tr> 
                        <td className="text-left col-sm-8 p-0" >Total Net Amount</td>
                        <td className="text-right col-sm-4 p-0"> {doubleToStringMonthly(this.totalAmtObj.totalNetAmt)}</td>
                    </tr>
                    </tbody>
            </table>
            <table className="text-white table table-hover">
                    <tbody>
                        <tr> 
                        <td className="text-left p-0" >FutureGameDate</td>
                        <td className="p-0 text-right"> {reformatDateToDisplay(this.newGameDate)}</td>
                    </tr>
                    {this.displaySavings ?
                        <tr> 
                            <td className="text-left p-0" >Total Savings Amt</td>
                            <td className="p-0 text-right"> {doubleToStringMonthly(this.totalSavingsAmt)}</td>
                        </tr>
                    :
                        null
                    }
                    <tr> 
                        <td className="text-left p-0" >Estimated Future Cash Amount</td>
                        <td className="p-0 text-right"> {doubleToStringMonthly(this.endingCashAmt)}</td>
                    </tr>
           
                </tbody>
            </table>
            {this.displaySavings ?
            
                <table className="text-white table table-hover">
                    <tbody>
                        <tr>
                            <td className="text-center p-0" colSpan="2">Total Savings Amounts</td>
                        </tr>
                        <tr>
                            <td className="text-left col-sm-8 ml-3 p-0">Current Savings Amt</td>
                            <td className="text-right p-0">{doubleToStringMonthly(this.currentSavingsAmt)}</td>
                        </tr>
                        <tr>
                            <td className="text-left col-sm-8 ml-3 p-0">Total Amt Deposited</td>
                            <td className="text-right p-0">{doubleToStringMonthly(this.savingsDeposits)}</td>
                        </tr>
                        <tr>
                            <td className="col-sm-8 p-0 text-left">Total Interest Earned</td>
                            <td className="col-sm-4 p-0 text-right">{doubleToStringMonthly(this.savingsIntAmt)}</td>
                        </tr>
                        <tr>
                            <td className="col-sm-8 p-0 text-left">Total Savings Amt</td>
                            <td className="col-sm-4 p-0 text-right">{doubleToStringMonthly(this.savingsAmt)}</td>
                        </tr>
                    </tbody>
                </table>
            :
                null
            }
            {this.loanArray.length > 0 ? 
                <span>
                    <div className="p-0 text-center text-white">Outstanding Loans</div>
                    <table className="text-white table table-hover">
                            <tbody className="row-100">
                            <tr>
                                <td className="col-sm-8 text-left p-0">Loan Type</td>
                                <td className="col-sm-4 text-right p-0">End Date</td>
                            </tr>
                            {this.collegeLoanList}
                        </tbody>
                    </table>
                </span>
            :
                    null
            }
            </span>
    </Modal.Body>
    <Modal.Footer className="futureModalHdrFooterBackground">
        <Button variant="primary"  onClick={() => this.props.onClose()}>
            Close
        </Button>
    </Modal.Footer>
    </Modal>
    </>
}

    componentDidMount(){
        this._isMounted = true;
    }
   
    backToOptionSelection() {
        this.props.onNavigate("status-display");
    }
    
}

export default FutureViewModal;